import { render } from "./RouteTo.vue?vue&type=template&id=089dc47e"
import script from "./RouteTo.vue?vue&type=script&lang=js"
export * from "./RouteTo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__